import ContentPageCatalog, { IContent } from "./ContentPageCatalog";

const contentList: IContent[] = [
  {
    id: "a",
    title: "设计背景",
    content: [
      "在本学期的《产品设计3》课程中，我们想要针对长途货车司机这一人群进行产品设计，希望能改善货车司机工作中的疲劳驾驶问题。然而，我们遇到了一系列的难题。当我们进行用户调研时发现，卡车司机的群体固然庞大，但他们的工作需要特定的驾驶证和车辆，作为学生，很难去体验他们真实的工作状态，也难以理解他们工作时的疲劳情况。当我们制作出一些交互原型后又发现，在真实的驾驶场景中对原型进行测试是一件非常危险的事，而仿真驾驶系统对于学生而言成本又太过高昂，且很少能找到合适的设备。",
      "于是，我们进一步联想到，不仅是驾驶，面对一些难以亲身体验或测试的特殊情境，如航空飞行、灾情等，在设计师前期的共情以及初步的原型测试阶段都会遇到模拟难度大、成本高的问题。那么，我们是否能提供一些可靠的工具，帮助设计师们更好地以低成本实现特色情境的模拟、帮助他们完成初步的共情或者测试？这便是我们设计KarKit的契机。",
    ],
  },
  {
    id: "b",
    title: "问题定义",
    content: [
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301051517375.png",
    ],
  },
  {
    id: "c",
    title: "痛点分析",
    content: [
      "1. 设计师难有机会共情到用户状态",
      "2. 前期原型测试安全隐患和成本消耗过大",
      "3. 前期经验少，耗费设计师大量时间",
    ],
  },
  {
    id: "d",
    title: "问题聚焦",
    content: [
      "怎样以的方式，让<strong>低技术低成本</strong>的方式，让<strong>设计师模拟特色情景</strong>，实现<strong>初步共情或者测试</strong>？",
    ],
  },
  {
    id: "e",
    title: "头脑风暴",
    content: [
      "为此，我们进行了一轮头脑风暴。",
      "在设计的共情环节，由于设计场景的特殊限制，存在一手调研/访谈样本数量不足，以及体验缺少资金、技术等多维度的学习体验门槛，设计师前期共情需要低成本的氛围的营造和行动的模拟引入。",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301051536860.png",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301051536858.png",
      "例如需要舱体视角的驾驶环境及极端工作环境特有的感知限制，我们希望应用AR技术构建一个模拟真实的视觉场景环境，或利用arduino元件建立在动作指令、信息传达等体验上尽量仿真的交互体验，从而帮助设计师发现设计痛点，触发设计灵感。",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301051536861.png",
    ],
  },
  {
    id: "f",
    title: "原型设计",
    content: [
      "最终，我们的设计目标是：设计一套低成本、更易用的驾驶状态与车辆状况模拟测试工具包。工具包使用物理微缩模型和远程数据传输，使用户能够在真实物理环境下模拟道路行进，避免计算机仿真的高成本和失真。",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301060125006.png",
      "工具包的将实验空间分为交互空间和测试空间：交互空间主要为被试（驾驶员、操作员）提供操作环境，测试空间主要为小车提供行驶环境。在交互空间，工具包会提供手机和电脑端的控制和信息传输软件，和一些用于制作驾驶工具的材料；在测试空间，工具包会提供带有摄像头的遥控小车，以及一些用于制作小车行驶环境的材料。",
      "除上述基础模拟驾驶模块外，工具包还可以提供驾驶舱模拟模块、驾驶环境模拟模块和车辆调整模块三个更高仿真度的附加模块，使用者可根据自己的需求选择对应模块使用，以降低模拟成本。",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301060125005.png",
      "工具包可以测试的目标：驾驶空间的环境营造与人机交互方式对驾驶状态的影响、车辆状况对的行驶状态（负荷等等）的影响、突发事件的感知与处理等等。",
      `设计特色：`,
      `①抓住测试空间的物理实际特点，用更真实的道路环境打造微缩版的真实测试环境；`,
      `②在测试空间真实模拟突发事件，进行有数据的、更直观方便的观测；`,
      `③通过自主选择高仿附加模块，可以增加交互空间、驾驶状态模拟的真实性。`,
    ],
  },
  {
    id: "g",
    title: "第一次测试",
    content: [
      "确定了初步方案后，我们利用手边的材料进行了第一次测试。我们计划利用这一工具去模拟卡车司机的驾驶场景，获得五感和认知刺激对于卡车司机专注度的影响。",
      "我们在工业设计专业教室开展测试。运用腾讯会议将小车上的手机与电脑连接，同时测试了直行、转弯和掉头的场景，并将刺激工具分为四大类：触觉、听觉、嗅觉和视觉。此外，我们还设置了不同机位的观察角度，使得用户和小车位都能得到详尽的观察。",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301060125008.png",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301060125007.png",
      "经过第一轮测试后，我们得到了听觉对于司机驾驶专注度的影响最小，并可以辅助以适量的嗅觉刺激，这对我们的进一步研究十分有价值，验证了设计想法的可行性。",
      "但是，我们也发现了这套工具的不足。首先，用户利用游戏手柄操控小车和实际场景中卡车司机的方向盘的操作模式相差太大，因此我们需要将用户控制小车的方式进行进一步细化。其次，在小车空间中，小车与建筑物的大小比例也需要一定的调试来达到更真实的交互效果。此外，在我们搭建现场与清理现场时，由于我们的材料较为零散，因此会消耗一定的不必要的时间且不便于清理。因此，我们想进一步对我们的工具进行一个模块化的处理。",
    ],
  },
  {
    id: "h",
    title: "第二次测试",
    content: [
      "经过第一次测试，验证了设计想法的可行性后，我们基于产品思维继续深化设计方案。",
      "为了测试我们更新的“驾驶场景组件”是否能够成功模拟第一视角的驾驶体验，我们开展了第二次测试。",
      "https://raw.githubusercontent.com/wujinhjun/wujinhjun-pic/main/202301060125009.png",
      "场地上，选择校园内室外空地作为测试场地。材料上，我们使用瓦楞纸搭建场景，放置交互触点；用魔术贴划定小车行进路线，粘连瓦楞纸组件和地面；用遥控小车替代自组装小车。记录方式上，以手机固定在小车上的方式替代小车上的摄像头，实现摄像记录功能。同时我们在场地外设置了一个固定机位，用于拍摄记录场地搭建过程、测试过程。",
      "结果表明，我们的测试空间设计可以满足“仿真用户第一视角的驾驶体验”的目的。 ",
    ],
  },
];

const Design = () => {
  return <ContentPageCatalog title="设计流程" contentList={contentList} />;
};

export default Design;
